import React, { useState, useContext } from 'react';
import { Modal, Button } from 'antd';
import { deleteCategory } from '../../utils/services/categoriesAPI';
import { Container, ModalBody } from './styles';
import { DESIGN_AREA_SETTINGS_TAB } from '../../containers/SidebarMenu/translationValues';
import { useTranslation } from 'react-i18next';
// app store context API
import { AppStoreContext } from '../../context/appStoreContext';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];
const DeleteCategoryModal = props => {
  const { visible, onCancel, targetElement, categoryType } = props;
  const { t } = useTranslation(NAMESPACES);
  const [deleting, setDeleting] = useState(false);
  const { updateCategoryElements, updateCategoryTemplates } = useContext(AppStoreContext);

  const onDelete = () => {
    const payload = {
      id: targetElement.id,
    };
    deleteElementCategory(payload);
  };

  const deleteElementCategory = async payload => {
    setDeleting(true);
    let deletionResponse = await deleteCategory(payload);
    if (deletionResponse && deletionResponse.errors && deletionResponse.errors.length === 0) {
      if (categoryType === 'element') {
        updateCategoryElements(targetElement, 'deleteElementCategory');
      } else {
        updateCategoryTemplates(targetElement, 'deleteTemplateCategory');
      }
      setDeleting(false);
      onCancel();
    } else {
      setDeleting(false);
    }
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={t(DESIGN_AREA_SETTINGS_TAB.DELETE_CATEGORY_MODAL_TITLE.key, DESIGN_AREA_SETTINGS_TAB.DELETE_CATEGORY_MODAL_TITLE.value)}
        centered
        visible={visible}
        width="625px"
        onCancel={onCancel}
        footer={[
          <Button key="back" onClick={onCancel}>
            {t(DESIGN_AREA_SETTINGS_TAB.CANCEL_DELETING_CATEGORY_BUTTON.key, DESIGN_AREA_SETTINGS_TAB.CANCEL_DELETING_CATEGORY_BUTTON.value)}
          </Button>,
          <Button key="submit" type="primary" loading={deleting} onClick={onDelete}>
          {deleting
            ? t(DESIGN_AREA_SETTINGS_TAB.DELETING_CATEGORY_BUTTON.key, DESIGN_AREA_SETTINGS_TAB.DELETING_CATEGORY_BUTTON.value)
            : t(DESIGN_AREA_SETTINGS_TAB.DELETE_CATEGORY_BUTTON.key, DESIGN_AREA_SETTINGS_TAB.DELETE_CATEGORY_BUTTON.value)}
        </Button>,
        ]}
        className="warning-modal"
      >
        <ModalBody>
          <div className="warning-text">
            <span>{t(DESIGN_AREA_SETTINGS_TAB.CATEGORY_DELETE_CONFIRMATION.key, DESIGN_AREA_SETTINGS_TAB.CATEGORY_DELETE_CONFIRMATION.value)}</span>
            {targetElement && targetElement.name && (
              <span className="text-highlighter">{targetElement.name}</span>
            )}
            <span>{t(DESIGN_AREA_SETTINGS_TAB.DELETE_CATEGORY.key, DESIGN_AREA_SETTINGS_TAB.DELETE_CATEGORY.value)}</span>
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
};
export default DeleteCategoryModal;
